import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSnackbarStore = defineStore('snackbar', () => {
  const queue = ref([]) // [{ text, color, timeout }, ...]

  const success = (msg, timeout = 4000) =>
    queue.value.push({ text: String(msg), color: 'success', timeout })

const successLong = (msg, timeout = 10000) =>
    queue.value.push({ text: String(msg), color: 'success', timeout })


  const error = (msg, timeout = 10000) =>
    queue.value.push({ text: String(msg), color: 'error', timeout })

//   const info = (msg, timeout = 5000) =>
//     queue.value.push({ text: String(msg), color: 'info', timeout })

  const clear = () => { queue.value = [] }

  // return { queue, success, error, info, clear }
  return { queue, success, successLong, error, clear }
})
